import BaseEmberPopover from 'ember-tooltips/components/ember-popover';

// Class ember-tooltips puts on the popover while it is shown, removed as soon as hiding starts
const SHOWN_CLASS = 'ember-tooltip-show';

export default class EmberPopover extends BaseEmberPopover {
  // Setting defaults for ember-popovers
  // Popper.js documentation: https://popper.js.org/docs/v1/
  popperContainer = 'body';

  popperOptions = {
    modifiers: {
      preventOverflow: {
        enabled: true,
        boundariesElement: 'viewport',
        priority: ['left', 'right', 'bottom', 'top'],
        escapeWithReference: false,
      },
    },
  };

  private get isOpen(): boolean {
    return Boolean(
      this._tooltip?.popperInstance?.popper.classList.contains(SHOWN_CLASS),
    );
  }

  // ember-tooltips writes its own visibility back into a two-way bound `@isShown`.
  // That echo makes it hide a hidden popover again (`onHide` fires again, so
  // resetting `@isShown` there loops) and show a shown one again (`onShow` fires twice).
  _hideTooltip(): void {
    if (this.isOpen) {
      super._hideTooltip();
    }
  }

  _showTooltip(): void {
    if (!this.isOpen) {
      super._showTooltip();
    }
  }
}
